var LocalStorageService = require('services/local-storage-service');

var ActionPlanItemResponsesService = function() {
  if (ActionPlanItemResponsesService.prototype._singleton){
    return ActionPlanItemResponsesService.prototype._singleton;
  }
  ActionPlanItemResponsesService.prototype._singleton = this;
  ActionPlanItemResponsesService._key = 'actionPlanItemResponses';

  this.readLocal = function(moduleKey) {
    var itemsJSON = LocalStorageService.getItem('actionPlanItemResponses') || '[]';
    return JSON.parse(itemsJSON);
  };

  this.writeLocal = function(list) {
    LocalStorageService.setItem('actionPlanItemResponses', JSON.stringify(list));
  };

  this.clear = function() {
    LocalStorageService.removeItem('actionPlanItemResponses');
  };
};

export default new ActionPlanItemResponsesService();